import { MakeLogicType, kea, path } from 'kea'
import { loaders } from 'kea-loaders'

import api from 'lib/api'
import { getAppContext } from 'lib/utils/getAppContext'

import type { UserProductListItem } from '~/queries/schema/schema-general'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface customProductsLogicValues {
    customProducts: UserProductListItem[]
    customProductsLoading: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface customProductsLogicActions {
    loadCustomProducts: () => any
    loadCustomProductsFailure: (
        error: string,
        errorObject?: any
    ) => {
        error: string
        errorObject?: any
    }
    loadCustomProductsSuccess: (
        customProducts: UserProductListItem[],
        payload?: any
    ) => {
        customProducts: UserProductListItem[]
        payload?: any
    }
}

export type customProductsLogicType = MakeLogicType<customProductsLogicValues, customProductsLogicActions>

export const customProductsLogic = kea<customProductsLogicType>([
    path(['layout', 'panel-layout', 'ProjectTree', 'customProductsLogic']),
    loaders(() => ({
        customProducts: [
            getAppContext()?.custom_products ?? [],
            {
                loadCustomProducts: async (): Promise<UserProductListItem[]> => {
                    const response = await api.userProductList.list()

                    return response.results ?? []
                },
            },
        ],
    })),
])
